import { render, staticRenderFns } from "./ResultEmail.vue?vue&type=template&id=928c1340&lang=pug&"
import script from "./ResultEmail.vue?vue&type=script&lang=js&"
export * from "./ResultEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports